import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"

import Image from "components/ui/image"
import Radio from "components/ui/radio"
import { to_currency } from "helpers/number"
import { useNavigation } from "helpers/use-navigation"

const planItems = [
  {
    alt: "Accident Protection",
    img: "fragile.svg",
    title: (
      <>
        Accident
        <br />
        Protection
      </>
    ),
  },
  {
    alt: "Fast Replacements and Repairs",
    img: "user-check.svg",
    title: (
      <>
        Fast Replacements
        <br />+ Repairs
      </>
    ),
  },
  {
    alt: "Easy Online Claims",
    img: "shield.svg",
    title: (
      <>
        Easy Online
        <br />
        Claims
      </>
    ),
  },
]

const WarrantyPlanItem = ({
  handleSelect,
  lineItemId,
  plan,
  selected,
  tabIndex,
}) => {
  const keyboardProps = useNavigation({ direction: "both" })

  return (
    <Radio
      checked={selected}
      className="border-primary inset-ring-2 size-16"
      id={`cart-line-item-warranty-plan-${lineItemId}-${plan.id}`}
      key={`warranty-plan-${plan.value}`}
      labelClassName="flex items-center gap-8 flex-wrap"
      name={`cart-line-item-warranty-plan-${lineItemId}`}
      onChange={handleSelect}
      tabIndex={tabIndex}
      value={plan.id}
      {...keyboardProps}
    >
      <p
        className="text-16 leading-20 mr-8"
        data-cy="warranty-addon-plan-price"
      >
        {plan.duration.toLowerCase()} protection plan &ndash;{" "}
        {to_currency(plan.price, { precision: 2 })}
      </p>
      {plan.label && (
        <span className="bg-light-blue text-11 flex h-20 shrink-0 grow-0 items-center justify-center rounded-sm px-12 font-semibold text-black">
          {plan.label}
        </span>
      )}
    </Radio>
  )
}

WarrantyPlanItem.propTypes = {
  handleSelect: PropTypes.func,
  lineItemId: PropTypes.string,
  plan: PropTypes.object,
  selected: PropTypes.bool,
  tabIndex: PropTypes.number,
}

const WarrantPlans = ({ item, selectWarrantyOption, selectedWarrantyPlan }) => {
  return (
    <>
      <FocusScope>
        <div
          aria-label="Select a protection plan"
          className="desktop:pl-24 flex w-full flex-col gap-10"
          role="radiogroup"
        >
          {item.warranty_plans.map((plan, index) => {
            const selected = plan.value === selectedWarrantyPlan?.addon_code

            return (
              <WarrantyPlanItem
                handleSelect={() => selectWarrantyOption(plan)}
                key={`warranty-plan-${plan.value}`}
                lineItemId={item.id}
                plan={plan}
                selected={selected}
                tabIndex={
                  selected || (!selectedWarrantyPlan && index === 0) ? 0 : -1
                }
              />
            )
          })}
        </div>
      </FocusScope>
      <div className="tablet:py-16 mx-auto mt-16 flex w-full items-center justify-center bg-white py-12 text-center">
        <div className="tablet:gap-48 grid grid-cols-3 gap-16">
          {planItems.map((item, i) => (
            <div key={`plan-item-${i}`}>
              <Image
                alt=""
                className="mb-6 w-20"
                height="18px"
                src={require(`images/cart/warranty/${item.img}`)}
                width="17px"
              />
              <p className="text-12 leading-16 font-medium tracking-tight">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

WarrantPlans.propTypes = {
  item: PropTypes.object,
  selectWarrantyOption: PropTypes.func,
  selectedWarrantyPlan: PropTypes.object,
}

export default WarrantPlans
